import { getAttachments } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { get } from "lodash";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchAttachments = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllAttachments },
	} = useAssetDetailsContext();

	return async (attachmentSearch?: string) => {
		setIsLoading(true);
		const res = await getAttachments(attachmentSearch || null);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			const allAttachmentsMap: any = {};
			rowsSource.forEach((row: any) => {
				allAttachmentsMap[row.FileName?.trim()] = row;
			});
			setIsLoading(false);
			setListAllAttachments(allAttachmentsMap);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
